import React from 'react';
import AtelierLayout from '@/components/atelier/AtelierLayout';
import AdminLayout from '@/components/admin/AdminLayout';
import { UsedTiresPanel } from '@/components/tires/UsedTiresPanel';

export default function UsedTiresPage({ atelier, auth, onLogout }) {
  if (atelier) return <AtelierLayout onLogout={onLogout}><div className="p-4"><UsedTiresPanel canDelete={false} /></div></AtelierLayout>;
  return <AdminLayout auth={auth} onLogout={onLogout}><div className="p-6"><UsedTiresPanel /></div></AdminLayout>;
}
